<template>
	<div>
		<div class="bookmark d-flex align-items-center justify-content-center" v-if="bookmark">
			<h1 class="mb-0 py-2 px-3">{{ bookmark }}</h1>
		</div>
		<div class="content-container">
			<choice-text
					v-bind:text="message"
			/>
		</div>
	    <div class="toggle-image-container" v-if="toggled">
	      [X]
	    </div>
	</div>
</template>

<script>
	import ChoiceMessage from './choice-message'
	import ChoiceText from './choice-text'

	export default {
		name: 'choice',
		components: {
      ChoiceMessage,
      ChoiceText
		},
		props: {
      index: {
        type: Number,
        required: true
      },
      format: {
        type: String,
        required: true,
      },
      message: {
        type: String,
        required: true
      },
      bookmarkIsAnonymous: {
        type: Boolean,
        required: false,
        default: false,
      },
      toggled: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object
      },
      bookmark: {
        type: String,
        required: true
      }
		}
	}
</script>
<style lang="less" scoped>
.choice {
  position: relative;
}

.content-container {
  position: relative;
}

.toggle-image-container {
  position: absolute;
  width: 28px;
  height: 28px;
  border-radius: 14px;

  top: 10px;
  right: 10px;

  img {
    position: absolute;
    left: -3px;
    top: -3px;
  }
}
</style>